export const Permission = {
  data: () => ({}),
  methods: {
    ShowPermisos ({ permisos, tableMain }) {
      if (permisos.descripcion.special === 'all-access') {
        tableMain.header.options.map(action => {
          action.hidden = ''
          if (action.options) {
            action.options.map(option => {
              option.hidden = ''
            })
          }
        })
        tableMain.body.actions.map(action => {
          action.hidden = ''
        })
        return
      }
      tableMain.header.options.map(action => {
        permisos.permisos.map(item => {
          if (action.code !== 'libre') {
            if (action.code === item.slug) {
              action.hidden = ''

              if (action.options) {
                action.options.map(subAction => {
                  permisos.permisos.map(permiss => {
                    if (subAction.code !== 'libre') {
                      if (subAction.code === permiss.slug) subAction.hidden = ''
                    }
                  })
                })
              }
            }
          }
        })
      })
      tableMain.body.actions.map(action => {
        permisos.permisos.map(item => {
          if (action.code !== 'libre') {
            if (action.code === item.slug) {
              action.hidden = ''
            }
          }
        })
      })
    },

    ShowPermisosMenu ({ permisos, MenuMain }) {
      if (permisos.descripcion.special === 'all-access') {
        MenuMain.map(action => {
          if (action.group) {
            action.hidden = ''
            action.items.map(subItems => {
              if (subItems.group) {
                subItems.hidden = ''
                subItems.items.map(subsubItems => {
                  subsubItems.hidden = ''
                })
              } else {
                subItems.hidden = ''
              }
            })
          } else {
            action.hidden = ''
          }
        })
        return
      }
      MenuMain.map(action => {
        permisos.permisos.map(item => {
          if (action.group) {
            if (item.slug === action.id) {
              action.hidden = ''
              action.items.map(subItems => {
                permisos.permisos.map(per => {
                  if (subItems.group) {
                    if (per.slug === subItems.id) {
                      subItems.hidden = ''
                      subItems.items.map(subsubItems => {
                        permisos.permisos.map(persub => {
                          if (persub.slug === subsubItems.id) {
                            subsubItems.hidden = ''
                          }
                        })
                      })
                    }
                  } else {
                    if (per.slug === subItems.id) {
                      subItems.hidden = ''
                    }
                  }
                })
              })
            }
            // action para los sub menu
          } else {
            if (item.slug === action.id) {
              action.hidden = ''
            }
          }
        })
      })
    },

    ReadOnlyPermiso (permisos, permiso) {
      if (permisos.descripcion.special === 'all-access') return true

      const acceso = permisos.permisos.find(item => item.slug === permiso)
      return (acceso)
    }
  }
}
